import Vue from 'vue'
import VeeValidate from 'vee-validate'
import VeeValidateLocaleRu from 'vee-validate/dist/locale/ru'
import VeeValidateLocaleEn from 'vee-validate/dist/locale/en'

Vue.use(VeeValidate, {
  locale: localStorage.getItem('locale') || 'en',
  dictionary: {
    en: VeeValidateLocaleEn,
    ru: VeeValidateLocaleRu,
    kz: VeeValidateLocaleRu
  }
})
